import React from 'react'
import moment from 'moment'
import { jt, t } from 'ttag'

import { Box } from 'components/layout/Box/Box'

import { InterviewStateContext } from 'components/modules/interview/context'
import { useContext } from 'hooks'

import styles from './Introduction.module.scss'

export const Introduction = () => {
  const state = useContext(InterviewStateContext)

  const {
    candidate: { company_name, name, project_name },
    questionsCount,
  } = state

  const role = (
    <strong className={styles.strong} key="role">
      {project_name}
    </strong>
  )

  const count = (
    <strong
      className={styles.strong}
      key="count"
    >{t`${questionsCount} questions`}</strong>
  )

  const time = (
    <strong className={styles.strong} key="time">{t`60 minutes`}</strong>
  )

  return (
    <Box className={styles.introduction} direction="column" tagName="section">
      <p className={styles.date}>{moment(new Date()).format('LL')}</p>
      <h1 className={styles.title}>{t`Interview with ${name}`}</h1>
      <h2 className={styles.subtitle}>{t`for ${company_name}`}</h2>
      <p className={styles.text}>{jt`The interview is for role of ${role}.`}</p>
      <p className={styles.text}>
        {jt`The interview will consist of ${count} and should take approximately ${time}.`}
      </p>
      <p className={styles.text}>
        {t`You will be prompted to evaluate answers of the candidate and write notes.`}
      </p>
    </Box>
  )
}
